// tslint:disable:max-line-length
import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../constants'

export const IMG_URL_DESKTOP_1 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/driving-jobs-part-time-driver-image-desktop%402x.jpg`
export const IMG_URL_DESKTOP_2 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/driving-jobs-food-courier-image-desktop@2x.jpg`

export const IMG_URL_1 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-part-time-driver-image-desktop@2x.jpg`
export const IMG_URL_2 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-delivery-driver-image-desktop@2x.jpg`
export const IMG_URL_3 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-food-delivery-driver-image-desktop@2x.jpg`
export const IMG_URL_4 = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-food-courier-image-desktop@2x.jpg`

export const JOB_DESCRIPTION_1 = `Deliver food and other items from merchants to hungry customers. Use any car to deliver.`
export const JOB_DESCRIPTION_2 = `No passengers. No bosses. Just you, your tunes, and the road. Work when you want, wherever you want.`
export const JOB_DESCRIPTION_3 = `Deliver food and other items from merchants to hungry customers. Use any car to deliver.`
export const JOB_DESCRIPTION_4 = `Make money delivering food. You choose whether to drive your car or ride a bike.`

export const BUTTON_NAME_1 = `See listing`
export const BUTTON_NAME_2 = `See listing`
export const BUTTON_NAME_3 = `See listing`
export const BUTTON_NAME_4 = `See listing`

// Static city names on /driving-opportunities home page
export const HOME_CITY_1 = `SF Bay Area`
export const HOME_CITY_SLUG_1 = 'sf-bay-area-ca'
export const HOME_CITY_2 = `New York Metro`
export const HOME_CITY_SLUG_2 = 'new-york-metro-ny'
export const HOME_DESCRIPTION_1 = `No passengers. No bosses. Just you, your tunes, and the road. Work when you want, wherever you want.`
export const HOME_DESCRIPTION_2 = `Make money delivering food. You choose whether to drive your car or ride a bike.`
